import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const getAuthHeader = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`
  }
});

// Transfers API
export const getTransfers = async (filters = {}) => {
  const params = new URLSearchParams(filters).toString();
  const response = await axios.get(
    `${API_BASE_URL}/transfers?${params}`,
    getAuthHeader()
  );
  return response.data.data;
};

export const getTransfer = async (id) => {
  const response = await axios.get(
    `${API_BASE_URL}/transfers/${id}`,
    getAuthHeader()
  );
  return response.data.data;
};

export const createTransfer = async (transferData) => {
  const response = await axios.post(
    `${API_BASE_URL}/transfers`,
    transferData,
    getAuthHeader()
  );
  return response.data.data;
};

export const approveTransfer = async (id, comments) => {
  const response = await axios.put(
    `${API_BASE_URL}/transfers/${id}/approve`,
    { comments },
    getAuthHeader()
  );
  return response.data.data;
};

export const rejectTransfer = async (id, comments) => {
  const response = await axios.put(
    `${API_BASE_URL}/transfers/${id}/reject`,
    { comments },
    getAuthHeader()
  );
  return response.data.data;
};

export const cancelTransfer = async (id) => {
  const response = await axios.delete(
    `${API_BASE_URL}/transfers/${id}`,
    getAuthHeader()
  );
  return response.data;
};

export const getTransferStats = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/transfers/stats`,
    getAuthHeader()
  );
  return response.data.data;
};

// Email API
export const getEmailSettings = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/email/settings`,
    getAuthHeader()
  );
  return response.data.data;
};

export const updateEmailSettings = async (settings) => {
  const response = await axios.put(
    `${API_BASE_URL}/email/settings`,
    settings,
    getAuthHeader()
  );
  return response.data.data;
};

export const sendTestEmail = async (to) => {
  const response = await axios.post(
    `${API_BASE_URL}/email/test`,
    { to },
    getAuthHeader()
  );
  return response.data;
};

export const getEmailStatus = async () => {
  const response = await axios.get(
    `${API_BASE_URL}/email/status`,
    getAuthHeader()
  );
  return response.data.data;
};
